import React from 'react';
import pt from 'prop-types';
import View from 'components/view';
import Action from 'partners/components/action';
import { NEW_APP_ACTIONS } from './configs';

export default class NewAppPage extends React.PureComponent {
  static propTypes = {
    onLinkApps: pt.func,
  };

  static contextTypes = {
    openModal: pt.func.isRequired,
  };

  onClickLinkApps = (event) => {
    event.preventDefault();

    const { openModal } = this.context;
    const { onLinkApps } = this.props;

    openModal('LinkApps', {
      onSubmit: onLinkApps,
    });
  };

  renderActions = () => {
    return NEW_APP_ACTIONS.map((action, i) => (
      <Action key={i} {...action} onClickLinkApps={this.onClickLinkApps} />
    ));
  };

  render() {
    return (
      <View full uri="/apps" sectionTitle="Apps" headerTitle="New app">
        {this.renderActions()}
      </View>
    );
  }
}
